// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ly-c";
export var backButton = "_ly-4";
export var backIcon = "_ly-5";
export var chevronShortcut = "_ly-6";
export var container = "_ly-1";
export var editor = "_ly-8";
export var editorWrapper = "_ly-7";
export var prefix = "_ly-2";
export var searchIcon = "_ly-3";
export var suffix = "_ly-9";
export var suffixContent = "_ly-a";
export var suffixText = "_ly-b";
export var wrapper = "_ly-0";